import React from "react";

const YoutubeIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.984"
      height="14.977"
      viewBox="0 0 19.984 14.977"
    >
      <path
        id="ytb_ic"
        d="M25.984,8.009a1.149,1.149,0,0,0-1.11-1.149H7.138A1.149,1.149,0,0,0,6,8v12.94a.9.9,0,0,0,.9.894H24.874a1.149,1.149,0,0,0,1.11-1.144Zm-6.928,6.611L14.221,17.4a.494.494,0,0,1-.744-.416v-5.4a.494.494,0,0,1,.733-.422l4.841,2.631a.472.472,0,0,1,.006.833Z"
        transform="translate(-6 -6.86)"
        fill={fill ? fill : "#707070"}
      />
    </svg>
  );
};

export default YoutubeIcon;
